const IndexMobile = () => import('views/vodm/IndexMobile')
const UserHome = () => import('views/userm/UserHome')
const UserVideo = () => import('views/userm/UserHome')
const UserImage = () => import('views/userm/UserHome')
const UserAlbum = () => import('views/userm/UserHome')
const UserRelation = () => import('views/userm/UserRelation')

export default {
  path: '/user',
  name: 'Index',
  component: IndexMobile,
  meta: { needAuth: false },
  children: [
    {
      path: '',
      name: 'User',
      component: () => import('@/views/404.vue'),
      meta: { needAuth: false }
    },
    {
      path: '/user/:id',
      name: 'UserHome',
      component: UserHome,
      meta: { needAuth: false }
    },
    {
      path: '/user/:id/video',
      name: 'UserVideo',
      component: UserVideo,
      meta: { needAuth: false }
    },
    {
      path: '/user/:id/image',
      name: 'UserImage',
      component: UserImage,
      meta: { needAuth: false }
    },
    {
      path: '/user/:id/album',
      name: 'UserAlbum',
      component: UserAlbum,
      meta: { needAuth: false }
    },
    {
      path: '/user/:id/following',
      name: 'UserFollowing',
      component: UserRelation,
      meta: { needAuth: false }
    },
    {
      path: '/user/:id/follower',
      name: 'UserFollower',
      component: UserRelation,
      meta: { needAuth: false }
    }
  ]
}
